"use client";

import { useNavigate } from "react-router-dom";
import AlertDialog from "../components/AlertDialog";

export default function QuickBooksError() {
  const navigate = useNavigate();

  const handleConfirm = () => {
    navigate("/"); // Redirect to root after confirming
  };

  return (
    <div className="min-h-screen bg-gray-900 text-gray-100 flex items-center justify-center">
      <AlertDialog
        type="error"
        title="Error"
        message="Failed to connect QuickBooks. Please try again."
        confirmText="OK"
        cancelText="Close"
        open={true} // Always open when on this page
        onClose={handleConfirm} // Redirect on close
        onConfirm={handleConfirm} // Redirect on confirm
        showCopyButton={false}
      />
    </div>
  );
}
